import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { loader } from "../../loader";

const AddTopicsModal = ({
  shown,
  clinicalTopic,
  functionTopic,
  setclinicalTopic,
  setfunctionTopic,
  selectedClinicalTopic,
  selectedFunctionTopic,
  setselectedClinicalTopic,
  setselectedFunctionTopic,
  handleAddClinicalTopic: externalHandleAddClinicalTopic,
  handleAddFunctionTopic: externalHandleAddFunctionTopic,
  getLibraryDataOnSave,
  onClose,
}) =>
{
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const [show, setShow] = useState(true);

  // New topic input states
  const [newClinicalTopic, setNewClinicalTopic] = useState("");
  const [newFunctionTopic, setNewFunctionTopic] = useState("");

  // Error states
  const [clinicalError, setClinicalError] = useState("");
  const [functionError, setFunctionError] = useState("");

  const handleClose = () =>
  {
    setShow(false);
    if (onClose) onClose(false);
    setFunctionError("");
    setClinicalError("");
    setNewClinicalTopic("");
    setNewFunctionTopic("");
  };

  // Toggle selection for clinical topics
  const toggleClinicalTopic = (topic) =>
  {
    if (selectedClinicalTopic.includes(topic)) {
      setselectedClinicalTopic(
        selectedClinicalTopic.filter((t) => t !== topic)
      );
    } else {
      setselectedClinicalTopic([...selectedClinicalTopic, topic]);
    }
  };

  // Toggle selection for functional topics
  const toggleFunctionTopic = (topic) =>
  {
    if (selectedFunctionTopic.includes(topic)) {
      setselectedFunctionTopic(
        selectedFunctionTopic.filter((t) => t !== topic)
      );
    } else {
      setselectedFunctionTopic([...selectedFunctionTopic, topic]);
    }
  };

  // Remove selected clinical topic
  const removeClinicalTopic = (topic) =>
  {
    setselectedClinicalTopic(selectedClinicalTopic.filter((t) => t !== topic));
  };

  // Remove selected functional topic
  const removeFunctionTopic = (topic) =>
  {
    setselectedFunctionTopic(selectedFunctionTopic.filter((t) => t !== topic));
  };

  // Validate input
  const validateInput = (value, type) =>
  {
    if (!value.trim()) {
      return "Topic name cannot be empty";
    }
    if (value.trim().length < 3) {
      return "Topic name must be at least 3 characters";
    }
    if (value.trim().length > 50) {
      return "Topic name must not exceed 50 characters";
    }

    const existingTopics = type === "clinical" ? clinicalTopic : functionTopic;
    if (
      existingTopics.some(
        (topic) => topic.toLowerCase() === value.trim().toLowerCase()
      )
    ) {
      return "This topic already exists";
    }

    return "";
  };

  // Add new clinical topic
  const handleAddClinicalTopic = async (e) =>
  {
    e.preventDefault();
    setClinicalError("");

    const error = validateInput(newClinicalTopic, "clinical");
    if (error) {
      setClinicalError(error);
      return;
    }

    if (externalHandleAddClinicalTopic) {
      const success = await externalHandleAddClinicalTopic(newClinicalTopic);
      if (success) {
        setselectedClinicalTopic([...selectedClinicalTopic, newClinicalTopic.trim()]);
        setNewClinicalTopic("");
      }
      return;
    }

    try {
      loader("show");
      const response = await postData(ENDPOINT.ADD_TAGS, {
        product: newClinicalTopic.trim(),
        type: 2,
        category: 0,
        irt: 0,
      });

      console.log(response);

      if (response.status != 201) {
        throw new Error("Failed to add topic");
      }
      const addedTopic = newClinicalTopic.trim();

      // Add to all topics list
      setclinicalTopic([...clinicalTopic, addedTopic]);

      // Add to selected topics
      setselectedClinicalTopic([...selectedClinicalTopic, addedTopic]);

      // Clear input
      setNewClinicalTopic("");
    } catch (error) {
      console.error("Error adding clinical topic:", error);
      setClinicalError("Failed to add topic. Please try again.");
    } finally {
      //  setClinicalLoading(false);
      loader("hide");
    }
  };

  // Add new functional topic
  const handleAddFunctionTopic = async (e) =>
  {
    e.preventDefault();
    setFunctionError("");

    const error = validateInput(newFunctionTopic, "function");
    if (error) {
      setFunctionError(error);
      return;
    }

    if (externalHandleAddFunctionTopic) {
      const success = await externalHandleAddFunctionTopic(newFunctionTopic);
      if (success) {
        setselectedFunctionTopic([...selectedFunctionTopic, newFunctionTopic.trim()]);
        setNewFunctionTopic("");
      }
      return;
    }

    loader("show");
    try {
      // API call to add topic
      const response = await postData(ENDPOINT.ADD_TAGS, {
        product: newFunctionTopic.trim(),
        type: 21,
        category: 0,
        irt: 0,
      });

      if (response.status != 201) {
        throw new Error("Failed to add topic");
      }
      const addedTopic = newFunctionTopic.trim();

      // Add to all topics list
      setfunctionTopic([...functionTopic, addedTopic]);

      // Add to selected topics
      setselectedFunctionTopic([...selectedFunctionTopic, addedTopic]);

      // Clear input
      setNewFunctionTopic("");
    } catch (error) {
      console.error("Error adding functional topic:", error);
      setFunctionError("Failed to add topic. Please try again.");
    } finally {
      loader("hide");
    }
  };

  const handleSave = async () =>
  {
    await getLibraryDataOnSave();
    handleClose();
  };

  return (
    <Modal show={shown} centered className="add-topics-modal">
      <Modal.Header>
        <h5 className="modal-title" id="staticBackdropLabel">
          Add Topics
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6 topic-left">
            <div className="topic-section">
              <h6 className="section-label">Select clinical topic :</h6>
              <div className="topics-box">
                <div className="topics-scroll">
                  {clinicalTopic.map((topic, index) => (
                    <div
                      key={index}
                      // className={`topics ${selectedClinicalTopic.includes(topic) ? 'selected' : ''}`}
                      className={`topics`}
                      onClick={() => toggleClinicalTopic(topic)}
                      style={{ cursor: "pointer" }}
                    >
                      {topic}
                    </div>
                  ))}
                </div>
              </div>
              <div className="arrow-down">
                <img src={path_image + "arrow-shape.svg"} alt="down-arrow" />
              </div>
            </div>

            <div className="selected-section">
              <h6 className="section-label">
                Selected topics <span>| {selectedClinicalTopic.length}</span>
              </h6>
              <div className="total-selected">
                <div className="topics-scroll">
                  {selectedClinicalTopic.map((topic, index) => (
                    <div key={index} className="tag-cross clinical">
                      {topic}
                      <img
                        src={path_image + "filter-close-blue.svg"}
                        alt="Close-filter"
                        onClick={() => removeClinicalTopic(topic)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="new-topics-section">
              <form onSubmit={handleAddClinicalTopic}>
                <div className="form-group">
                  <label>New Topics</label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      className={`form-control ${clinicalError ? "is-invalid" : ""
                        }`}
                      value={newClinicalTopic}
                      onChange={(e) =>
                      {
                        setNewClinicalTopic(e.target.value);
                        setClinicalError("");
                      }}
                      placeholder="Enter clinical topic"
                    />
                    {clinicalError && (
                      <div className="invalid-feedback d-block">
                        {clinicalError}
                      </div>
                    )}
                  </div>
                  <button
                    onClick={handleAddClinicalTopic}
                    type="submit"
                    className="btn btn-primary btn-bordered"
                  >
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-6 topic-right">
            <div className="topic-section">
              <h6 className="section-label">Select functional topic :</h6>
              <div className="topics-box">
                <div className="topics-scroll">
                  {functionTopic.map((topic, index) => (
                    <div
                      key={index}
                      // className={`topics functional ${selectedFunctionTopic.includes(topic) ? 'selected' : ''}`}
                      className={`topics functional`}
                      onClick={() => toggleFunctionTopic(topic)}
                      style={{ cursor: "pointer" }}
                    >
                      {topic}
                    </div>
                  ))}
                </div>
              </div>
              <div className="arrow-down">
                <img src={path_image + "arrow-shape.svg"} alt="down-arrow" />
              </div>
            </div>

            <div className="selected-section">
              <h6 className="section-label">
                Selected topics <span>| {selectedFunctionTopic.length}</span>
              </h6>
              <div className="total-selected">
                <div className="topics-scroll">
                  {selectedFunctionTopic.map((topic, index) => (
                    <div key={index} className="tag-cross functional">
                      {topic}
                      <img
                        src={path_image + "filter-close.svg"}
                        alt="Close-filter"
                        onClick={() => removeFunctionTopic(topic)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="new-topics-section">
              <form onSubmit={handleAddFunctionTopic}>
                <div className="form-group">
                  <label>New Topics</label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      className={`form-control ${functionError ? "is-invalid" : ""
                        }`}
                      value={newFunctionTopic}
                      onChange={(e) =>
                      {
                        setNewFunctionTopic(e.target.value);
                        setFunctionError("");
                      }}
                      placeholder="Enter functional topic"
                    />
                    {functionError && (
                      <div className="invalid-feedback d-block">
                        {functionError}
                      </div>
                    )}
                  </div>
                  <button
                    onClick={handleAddFunctionTopic}
                    type="submit"
                    className="btn btn-primary btn-bordered"
                  >
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="btn btn-primary btn-filled"
          className="save-btn"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTopicsModal;
